
/**
 * Сбор гугл-аналитики
 */
module.exports = function sendAnalyticsEvents(eventClass, event, domainName, conversionValue) {
    domainName = domainName || false;
    conversionValue = conversionValue || false;
    var gaArgs = function () {
        var tracker = window.ga.getAll()[0];

        if (tracker && !domainName && !conversionValue) {
            tracker.send("event", eventClass, event);
        }

        if (tracker && domainName && !conversionValue) {
            tracker.send("event", eventClass, event, domainName);
        }

        if (tracker && !domainName && conversionValue) {
            tracker.send("event", eventClass, event, "empty", Math.ceil(conversionValue));
        }

        if (tracker && domainName && conversionValue) {
            tracker.send("event", eventClass, event, domainName, Math.ceil(conversionValue));
        }
    }

    if ("ga" in window) {
        ga(gaArgs);
    }

    if (!!yaCounter51668960) {
        yaCounter51668960.reachGoal(eventClass + '_' + event);
    }

    if (!!fbq) {
        let fbqEventMap = {
                'DN_AddToCart': 'AddToCart',
                'DN_BuyNow': 'BuyNow',
                'Pay': 'Pay',
            },
            fbqEventName = fbqEventMap[eventClass] || eventClass;

        fbq('track', fbqEventName);
    }
}
